<section class="license-v2-panel" *ngIf="data" #panelEl>
  <div *ngIf="!isMobile" class="license-v2-panel__first">
    <div *ngIf="items" class="license-v2-panel__first-item">
      <div class="license-v2-panel__first-item--grid" #itemEl>
        <div class="license-v2-panel__first-item--left">
          <h3 class="license-v2-panel__header">{{ items[0].header.value }}</h3>
          <div class="license-v2-panel__price">{{ items[0].price.value }}</div>
          <app-bg-button class="license-v2-panel__link" [data]="items[0].link.value" [buttonColor]="items[0].linkColor.value"></app-bg-button>
          <div *ngIf="items[0].state === 'closed'"
               class="license-v2-panel__toggle"
               (click)="toggleItems(items[0])">
            <div class="license-v2-panel__toggle--line"></div>
          </div>
        </div>
        <div class="license-v2-panel__first-item--right" #imageEl>
          <div class="license-v2-panel__first-item--svg">
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122 708"><defs><style>
                                                                                                                   .cls-1 {
                                                                                                                     fill: #fff;
                                                                                                                   }
            </style></defs><polygon class="cls-1" points="0 708 122 708 122 442 121.5 442.5 33 354 121.5 265.5 122 266 122 0 0 0 0 708" /></svg>
          </div>
          <p class="license-v2-panel__information" [innerHTML]="items[0].information.value | safe"></p>
        </div>
      </div>
      <div class="license-v2-panel__first-item--grid">
        <div *ngIf="bulletLeft"
             class="license-v2-panel__first-item--bullets"
             [ngClass]="{'license-v2-panel__first-item--bullets__opened' : items[0].state == 'opened'}"
             [@info]="items[0].state">
          <div *ngFor="let item of bulletLeft;" #bulletEl>
            <ul>
              <li><div [innerHTML]="item.description.value | safe"></div></li>
            </ul>
          </div>
        </div>
        <div *ngIf="bulletRight"
             class="license-v2-panel__first-item--bullets"
             [ngClass]="{'license-v2-panel__first-item--bullets__opened' : items[0].state == 'opened'}"
             [@info]="items[0].state">
          <div *ngFor="let item of bulletRight;" #bulletEl>
            <ul>
              <li><div [innerHTML]="item.description.value | safe"></div></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="items[0].state === 'opened'"
         class="license-v2-panel__toggle"
         (click)="toggleItems(items[0])"
         [@arrow]="items[0].state"
         #bulletEl>
      <div class="license-v2-panel__toggle--line"></div>
    </div>
  </div>

  <div *ngIf="isMobile; then mobileView else desktopView;"></div>

</section>

<ng-template #desktopView>
  <div *ngIf="items[1]" class="license-v2-panel__cards">
    <div *ngFor="let card of items | slice : 1; let i = index;">
      <div class="license-v2-panel__cards--item" #itemEl>
        <div class="license-v2-panel__cards--item-top" #cardImageEl>
          <h3 class="license-v2-panel__header">{{ card.header.value }}</h3>
          <div class="license-v2-panel__price">{{ card.price.value }}</div>
          <app-bg-button [data]="card.link.value" [buttonColor]="card.linkColor.value"></app-bg-button>
          <div class="license-v2-panel__svg">
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 708 122"><defs><style>
                                                                                                                   .cls-1 {
                                                                                                                     fill: #fff;
                                                                                                                   }
            </style></defs><polygon class="cls-1" points="0 0 0 122 266 122 265.5 121.5 354 33 442.5 121.5 442 122 708 122 708 0 0 0" /></svg>
          </div>
        </div>
        <div class="license-v2-panel__cards--item-bottom">
          <div class="license-v2-panel__information" [innerHTML]="card.information.value | safe"></div>
          <div *ngIf="card.state === 'opened'" class="license-v2-panel__line"></div>
          <div *ngIf="card.items.value;"
               class="license-v2-panel__cards--bullets"
               [@info]="card.state">
            <div *ngFor="let bullet of card.items.value;" #bulletEl>
              <ul>
                <li><div [innerHTML]="bullet.description.value | safe"></div></li>
              </ul>
            </div>
          </div>
          <div *ngIf="card.items.value.length != 0"
               class="license-v2-panel__toggle"
               [@arrow]="card.state"
               (click)="toggleItems(card)">
            <div class="license-v2-panel__toggle--line"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #mobileView>
  <div *ngIf="items[0]" class="license-v2-panel__cards">
    <div *ngFor="let card of items; let i = index;">
      <div class="license-v2-panel__cards--item" #itemEl>
        <div class="license-v2-panel__cards--item-top" #cardImageEl>
          <h3 class="license-v2-panel__header">{{ card.header.value }}</h3>
          <div class="license-v2-panel__price">{{ card.price.value }}</div>
          <app-bg-button [data]="card.link.value" [buttonColor]="card.linkColor.value"></app-bg-button>
          <div class="license-v2-panel__svg">
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 708 122">
              <defs>
                <style>
                  .cls-1 {
                    fill: #fff;
                  }
                </style>
              </defs>
              <polygon class="cls-1" points="0 0 0 122 266 122 265.5 121.5 354 33 442.5 121.5 442 122 708 122 708 0 0 0" />
            </svg>
          </div>
        </div>
        <div class="license-v2-panel__cards--item-bottom">
          <div class="license-v2-panel__information" [innerHTML]="card.information.value | safe"></div>
          <div *ngIf="card.state === 'opened'" class="license-v2-panel__line"></div>
          <div *ngIf="card.items.value;"
               class="license-v2-panel__cards--bullets"
               [@info]="card.state">
            <div *ngFor="let bullet of card.items.value;" #bulletEl>
              <ul>
                <li><div [innerHTML]="bullet.description.value | safe"></div></li>
              </ul>
            </div>
          </div>
          <div *ngIf="card.items.value.length != 0"
               class="license-v2-panel__toggle"
               [@arrow]="card.state"
               (click)="toggleItems(card)">
            <div class="license-v2-panel__toggle--line"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

